<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="d-md-down-none">
      <b-nav-item to="/dashboard" class="px-3" exact><i class="fa fa-tachometer"></i> {{$t('header.dashboard')}}</b-nav-item>
      <b-nav-item to="/profile" class="px-3" exact><i class="fa fa-user"></i> {{$t('header.profile')}}</b-nav-item>
      <Language/>
      <!-- <b-nav-item to="#" class="px-3" @click="fullScreen"><i class="fa fa-arrows-alt"></i> {{$t('header.fullscreen')}}</b-nav-item> -->
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <notification/>
      <!-- <b-nav-item class="d-md-down-none" @click="asideToggle">
        <i class="fa fa-users"></i>
        <b-badge pill variant="primary">{{users.length}}</b-badge>
      </b-nav-item> -->
      <User/>
    </b-navbar-nav>
  </header>
</template>
<script>
import screenfull from 'screenfull'
import User from './User.vue'
import Language from './Language.vue'
import Notification from './notification'
export default {
  components: {
    User,
    Language,
    Notification
  },
  computed: {
    users () {
      return this.$store.getters['User/getUserOnline']
    }
  },
  name: 'c-header',
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
      this.$store.dispatch('User/getUserOnline')
    },
    fullScreen () {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue